module.exports = __webpack_public_path__ + "static/media/dollar-sign.a2fb8c1f.svg";